<template>
    <b-btn v-if="!AllowSecondLang" :disabled="!loadPrint||disable||filterDisable" class="font-weight-bold px-2 py-4"
           style="background: orange;border-radius: 15px ;font-size:1.1rem"
           @click="printTicket">
        <span class="font-weight-bold">Print Ticket</span>
    </b-btn>
    <b-btn v-else :disabled="!loadPrint||disable||filterDisable" class="font-weight-bold px-2 py-4" style="background: orange;border-radius: 15px;font-size:1.1rem" @click="goPrintPage">
        <span class="font-weight-bold">Print Ticket</span>
    </b-btn>
</template>

<script>
    

    export default {
        name: "printTicket",
        props: {
            items: {required: true},
            printMethod: {required: true,
            default: "API"},
            loadPrint: {required: true},
            AllowSecondLang: {required: true},
            serverIp: {required: true},
            isSpecialEvent: {required: false},
            info: {
                required: true
            },
            disabled: {required: true}
        },
        data(){
            return{
                disable:false,
            }
        },
        
        computed: {
            selectedItems () {
                const filter = this.items.filter(i => i.checked)
                return filter
            },
            filterDisable(){
                if((this.info.OrderTypeID === 1 || this.info.OrderTypeID === 3) && this.info.OrderStatusID === 1){
                    return true
                }
                return false
                
            }
        },
        methods: {
            goPrintPage () {
                if(this.printMethod.toUpperCase() === "API"){//run new code
                    return this.printTicket()
                }//fallback to old code
                let filter = this.items.filter(i => i.checked).map(item => {
                    return item.IKey
                })
                if (this.items.filter(i => i.checked).length) {
                    window.open(`${this.$config.websiteUrl}/print.aspx?RestaurantId=${this.$store.state.selectedRestaurantId}&OrderId=${this.info.OrderID}&serverIp=${this.serverIp}&SelectedIds=${filter.join(',')}`, '', "toolbar=yes,scrollbars=yes,resizable=yes,top=400,left=400,width=400,height=400")
                    this.items.filter(i => i.checked).forEach(item => {
                        item.success = true
                    })
                    this.$emit('callbackTicketPrint')
                }
            },
            printTicket () {
                this.disable = true
                if(this.printMethod.toUpperCase() === "API"){//run new code
                    const model = {
                        RestaurantID:this.$store.state.selectedRestaurantId,
                        OrderID:this.info.OrderID,
                        Type:"ticket",
                        SelectedIds:[]       
                    }
                    //console.log(this.items)
                    const filter = this.items.filter(i => i.checked)
                    
                    if(filter.length === 0)//no checked
                        return




                    const selectedItems = []
                    filter.forEach((i)=>{
                        selectedItems.push({
                            IpAddress:i.PrinterIP,
                            Port: i.Port,
                            ItemID: i.IKey
                        })    
                    })
                    let found
                    const uniqueIpPortCombos = []
                    selectedItems.forEach(el=>{
                        found = false
                        uniqueIpPortCombos.forEach(i=>{
                            if(el.IpAddress === i.IpAddress && el.Port === i.Port)
                                found = true
                        })
                        if(!found&&el.IpAddress != "" && el.Port != "")
                            uniqueIpPortCombos.push({
                                IpAddress:el.IpAddress,
                                Port:el.Port,
                                ItemIDs:""
                            })
                    })
                    uniqueIpPortCombos.forEach(el=>{
                        selectedItems.forEach(i=>{
                            if(el.IpAddress === i.IpAddress && el.Port === i.Port){
                                if(el.ItemIDs === "")
                                    el.ItemIDs += `${i.ItemID}`
                                else
                                    el.ItemIDs += `,${i.ItemID}`
                                    
                            }
                        })  
                    })
                    model.SelectedIds = uniqueIpPortCombos
                    
                    if(model.SelectedIds.length > 0){//printable items exist
                        this.$api.getRestaurant.SendOrderPrintToApp(model).then(res=>{
                            

                            if(!res.success){
                                filter.forEach(el=>{
                                    el.success = false,
                                    el.failur = true,
                                    el.printed=false
                                })
                                this.$emit('callbackTicketPrint')
                                this.$emit('callbackResult', {
                                hasError: true,
                                printTab: true,
                                message: "Error occured during printing"
                                })
                            }else{//no error

                                filter.forEach(el=>{
                                    el.success = true,
                                    el.failur = false,
                                    el.printed=true
                                })
                                this.$emit('callbackTicketPrint')

                            }
                            this.disable = false

                            
                        })

                    }else{
                        this.$emit('callbackResult', {
                        hasError: true,
                        printTab: true,
                        message: "Missing Printer Information"
                        })
                        this.disable = false
                    }

                    return 
                }
                
                this.disable = false
            },
            
        }
    }
</script>

<style scoped>
    .btn.disabled, .btn:disabled {
        color: #90a4ae !important;
        background: #eceff1 !important;
        border: 1px solid #eceff1 !important;
    }
</style>
